import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import web5 from "../img/pharma.jpg";
import "../style/styles.css";
import "../style/Pharma.css";

const Pharma = () => {
  const quickStats = [
    { value: "GST", label: "Enabled Billing" },
    { value: "Batch", label: "Wise Stock" },
    { value: "Expiry", label: "Near Expiry Alerts" },
    { value: "MIS", label: "Sales & Purchase Analysis" },
  ];

  const coreModules = [
    {
      title: "Sales",
      text:
        "Manage billing, cash billing, customer-product sales, company-group sales, product-wise monthly sales, year-to-year sales, non-supplied products, projecting sales analysis and barcode / QR code generation.",
    },
    {
      title: "Purchase",
      text:
        "Analyze product-group, company, division, supplier and product-wise purchase data with monthly purchase, cumulative purchase and Y2K analysis reports.",
    },
    {
      title: "Stock Reports",
      text:
        "Control company-division-product stock status, product summary, closing stock, location-wise stock, batch-wise stock, damage stock, slow moving stock, high value stock and expiry reports.",
    },
    {
      title: "Outstanding Reports",
      text:
        "Monitor debtor balance, creditor balance and ageing analysis for debtors and creditors with bill-by-bill ageing support.",
    },
    {
      title: "Accounting Reports",
      text:
        "Generate cash bank book, journal book, purchase, sales, return, ledger, trial balance, profit and loss, bank reconciliation, cost centre and GST reports.",
    },
    {
      title: "Profit & Expiry Analysis",
      text:
        "Use batch-wise stock, near expiry, slow moving item statement, profit analysis, sales analysis and purchase analysis for better distributor control.",
    },
  ];

  const salesFeatures = [
    "Billing",
    "Cash Billing",
    "Customer-Product Wise Sales-Date and Month wise",
    "Customer-Product Wise Sales-(Y2K Analysis)",
    "Company-Group Wise Sales-Date and Month wise",
    "Company-Group Wise Sales-(Y2K Analysis)",
    "Sub-Group/Division Wise Sales-Date and Month wise",
    "Sub-Group/Division Wise Sales-(Y2K Analysis)",
    "Area-Customer-Product Wise Sales-Date and Month wise",
    "Area-Customer-Product Wise Sales-(Y2K Analysis)",
    "Product Wise Sales",
    "Products Wise Monthly Sales",
    "Products Wise Monthly Sales (Y2Y)",
    "Year-to-Year Product Sales",
    "Analysis of Non-Supplied product",
    "Projecting Sales Analysis",
    "Barcode / QR Code Generated",
  ];

  const purchaseFeatures = [
    "Product-Group/Company-Month Wise Purchase",
    "Division/Sub-Group-Monthly Purchase",
    "Purchase query",
    "Cumulative Analysis of Purchase",
    "Company/Group Wise Purchase-Date and Month wise",
    "Company Group Wise Purchase-(Y2K Analysis)",
    "Product Analysis of Purchase",
    "Purchase-Product Analysis (Y2K Analysis)",
    "Supplier-Product-Division Wise Purchase Analysis",
    "Supplier-Product-Division Wise Monthly Purchase Analysis",
    "Supplier-Product-Division Wise Purchase Analysis(Y2k)",
  ];

  const stockFeatures = [
    "Company-Division-Product wise Stock Status",
    "Product wise Stock Summary",
    "Company-Division-Product wise Closing Stock",
    "Order Processing against Order Label",
    "Maximum and Minimum Label Register",
    "Damage Stock Summary",
    "Location wise Stock Status",
    "Graphical Analysis of Stock Status",
    "Location Wise Stock Summary",
    "Slow Moving Product Stock Summary",
    "High Value Product Stock Summary",
    "Batch Wise Stock Summary",
    "Batch wise Stock Summary and Closing Stock",
    "Breakage & Expiry Stock Report",
    "Near Expiry Reports with closing stock",
  ];

  const outstandingFeatures = [
    "Debtor's Balance Summary",
    "Aging Analysis(Debtors/Creditors)",
    "Creditor's Balance Summary",
    "Aging Analysis (Bill by bill Analysis)",
  ];

  const accountingFeatures = [
    "Cash Bank Book",
    "Journal Book",
    "Purchase Register",
    "Purchase Return Register",
    "Sales Register",
    "Sales Return Register",
    "Ledger",
    "Trial Balance",
    "Trading and Profit & Loss Statement",
    "Bank Reconciliation",
    "Interest Calculation",
    "Confirmation of Accounts",
    "Cost Centre Reports",
    "GST Type Wise Sales Register",
    "GSTR(GSTR-I,GSTR-II,GSTR3B) Reports",
  ];

  const handleImageError = (event) => {
    event.currentTarget.style.display = "none";
  };

  return (
    <main className="pharma-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Pharmacist - GST enabled Medicine Distributor and Retail Software | EBS Software Solution
        </title>
        <meta
          name="description"
          content="Pharmacist is a GST enabled medicine distributor and retail software with accounting, inventory control, batch wise stock, near expiry, profit analysis, slow moving item statement, sales analysis, purchase analysis and accounting reports."
        />
      </Helmet>

      <section className="pharma-hero">
        <img
          className="pharma-hero-bg"
          src={web5}
          alt="Pharmacist Medicine Distributor and Retail Software"
          onError={handleImageError}
        />
        <div className="pharma-hero-overlay"></div>

        <Container className="pharma-hero-container">
          <Row className="align-items-center g-4">
            <Col lg={7}>
              <div className="pharma-hero-content">
                <div className="pharma-kicker">Medicine Distributor / Dealer / Retail Software</div>
                <h1>Pharmacist</h1>
                <h2>GST enabled Medicine Distributor and Retail Software</h2>
                <p>
                  An Integrated Accounting and Inventory Controlling System for
                  Medicine Distributor&apos;s with wide variety of reports. And
                  also its cover Batch Wise Stock Status, Near Expiry. Profit
                  analysis, slow moving item statement, various analysis of
                  sales and purchase and also cover full accounting analysis.
                  Projecting sales analysis.
                </p>

                <div className="pharma-hero-actions">
                  <a href="#pharma-modules" className="pharma-btn pharma-btn-primary">
                    View Features
                  </a>
                  <Link to="/EmailContactForm" className="pharma-btn pharma-btn-outline">
                    Request Demo
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={5}>
              <div className="pharma-price-card">
                <span>1 Licence / Multi-User</span>
                <strong>₹15,000/- + GST</strong>
                <p>
                  Designed for medicine distributors, dealers and retail shops
                  with batch, expiry, inventory, billing and accounting control.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pharma-stats-section">
        <Container>
          <Row className="g-3">
            {quickStats.map((item) => (
              <Col lg={3} md={6} key={item.label}>
                <div className="pharma-stat-card">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="pharma-overview-section">
        <Container>
          <Row className="g-4 align-items-center">
            <Col lg={6}>
              <div className="pharma-section-label">Overview</div>
              <h2 className="pharma-section-title">
                Integrated accounting and inventory control for pharma business
              </h2>
              <p className="pharma-text">
                Pharmacist is designed for medicine distributors, dealers and
                retailers who need accurate inventory control, batch-wise stock,
                near-expiry reporting, profit analysis and accounting reports.
              </p>
              <p className="pharma-text">
                The system helps manage sales, purchases, stock, outstanding and
                full accounting analysis from one practical business software.
              </p>
            </Col>

            <Col lg={6}>
              <div className="pharma-overview-card">
                <h3>Pharmacist covers</h3>
                <div className="pharma-overview-grid">
                  <div><span>✓</span><p>Sales</p></div>
                  <div><span>✓</span><p>Purchase</p></div>
                  <div><span>✓</span><p>Batch Stock</p></div>
                  <div><span>✓</span><p>Near Expiry</p></div>
                  <div><span>✓</span><p>Outstanding</p></div>
                  <div><span>✓</span><p>Accounting & GST</p></div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pharma-modules-section" id="pharma-modules">
        <Container>
          <div className="pharma-heading-center">
            <div className="pharma-section-label">Key Features</div>
            <h2 className="pharma-section-title">
              Medicine distributor workflow from billing to final accounts
            </h2>
            <p>
              Pharmacist connects sales, purchase, stock, batch, expiry,
              outstanding and accounting reports in one organized pharma
              business platform.
            </p>
          </div>

          <Row className="g-4">
            {coreModules.map((module, index) => (
              <Col lg={4} md={6} key={module.title}>
                <div className="pharma-module-card">
                  <div className="pharma-module-number">
                    {String(index + 1).padStart(2, "0")}
                  </div>
                  <h3>{module.title}</h3>
                  <p>{module.text}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="pharma-feature-list-section">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="pharma-list-card">
                <div className="pharma-section-label">Sales</div>
                <h2>Billing and sales analysis reports</h2>
                <ul>
                  {salesFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="pharma-list-card pharma-list-card-dark">
                <div className="pharma-section-label">Purchase</div>
                <h2>Purchase analysis and supplier reports</h2>
                <ul>
                  {purchaseFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pharma-feature-list-section pharma-feature-list-alt">
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <div className="pharma-list-card">
                <div className="pharma-section-label">Stock Reports</div>
                <h2>Batch, expiry and stock control</h2>
                <ul>
                  {stockFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>

            <Col lg={6}>
              <div className="pharma-list-card">
                <div className="pharma-section-label">Outstanding Reports</div>
                <h2>Debtor, creditor and ageing analysis</h2>
                <ul>
                  {outstandingFeatures.map((item) => (
                    <li key={item}><span>✓</span>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pharma-accounting-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg={5}>
              <div className="pharma-accounting-title">
                <div className="pharma-section-label">Accounting Reports</div>
                <h2 className="pharma-section-title">
                  Full accounting and GST reporting
                </h2>
                <p>
                  Pharmacist covers accounting reports for cash, bank, journal,
                  purchase, sales, returns, ledger, trial balance, profit and
                  loss, reconciliation, cost centre and GST.
                </p>
              </div>
            </Col>

            <Col lg={7}>
              <div className="pharma-accounting-grid">
                {accountingFeatures.map((item) => (
                  <div key={item}>
                    <span>✓</span>
                    <p>{item}</p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pharma-cta-section">
        <Container>
          <div className="pharma-cta-card">
            <div>
              <span>Ready to manage your pharma business professionally?</span>
              <h2>Use Pharmacist for billing, batch stock, expiry and accounts.</h2>
              <p>
                Get a GST enabled medicine distributor and retail software with
                sales, purchase, stock, outstanding and accounting reports.
              </p>
            </div>
            <Link to="/EmailContactForm" className="pharma-btn pharma-btn-light">
              Request Demo
            </Link>
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Pharma;
